import React, { useState, useEffect } from "react";
import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";
import myMarkers from "../../puntos_wifi.json"
import mapStyles from "./mapStyles";

function Map() {
  const [selectedPark, setSelectedPark] = useState(null);
let tiposS = localStorage.getItem("misTipos");
console.log(localStorage.getItem("misTipos"));
//console.log("segundillo");
  let tipos="";
  if (tipos!=null){
  tipos=tiposS.split(',');} 

  useEffect(() => {
    const listener = e => {
      if (e.key === "Escape") {
        setSelectedPark(null);
      }
    };
    window.addEventListener("keydown", listener);

    return () => {
      window.removeEventListener("keydown", listener);
    };
  }, []);

  console.log(tipos);

  return (
    <GoogleMap
      defaultZoom={16}
      defaultCenter={{ lat: -34.4597619, lng: -58.9134961 }}
      defaultOptions={{ styles: mapStyles }}
    >
        {myMarkers.puntos
        .filter((x)=>{
          
          return tipos.indexOf(x.tipo)!=-1;
        }).map(park =>  
        
        (
        <Marker
          key={park.latitud+" "+park.longitud+" "+park.nombre}
          position={{
            lat: parseFloat(park.latitud),
            lng: parseFloat(park.longitud),
          }}
          onClick={() => {
            setSelectedPark(park);
          }}
          icon={{
            url: park.icono,
            scaledSize: new window.google.maps.Size(25, 35)
          }}
        />
      ))}

      {selectedPark && (
        <InfoWindow
          onCloseClick={() => {
            setSelectedPark(null);
          }}
          position={{
            lat: parseFloat(selectedPark.latitud),
            lng: parseFloat(selectedPark.longitud)
          }}
        >
          <div>
            <h2>{selectedPark.tipo}</h2>
            <p>{selectedPark.nombre}</p>
            <p><a class="buttonMicroClip" href={"https://maps.google.com/?q="+selectedPark.latitud+","+selectedPark.longitud}>Como llegar</a></p>

          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
}

const MapWrapped = withScriptjs(withGoogleMap(Map));

export default function Mapa({tipos}) {
  //console.log("Holi");
  //console.log(tipos);
  //console.log(tipos[0]);
  //localStorage.setItem("misTipos", tipos);
  return (
    <div style={{ width: "100vw", height: "60vh" }}>
      <MapWrapped
        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${
          "AIzaSyBauEMXNpAYf2wrK_QcSN2MZca80lWR-vI"
        }`}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `100%` }} />}
        mapElement={<div style={{ height: `100%` }} />}
      />
    </div>
  );
}
